import {
    HttpClientModule, HTTP_INTERCEPTORS, HttpInterceptor, HttpRequest,
    HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse,
    HttpUserEvent, HttpErrorResponse
} from '@angular/common/http';
import { NgModule, Pipe, PipeTransform, APP_INITIALIZER, ApplicationRef, Injector, ModuleWithProviders, InjectionToken } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ToastrModule } from 'ngx-toastr'
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { MsalComponent } from 'src/app/shared/msal.component';
//import { ExportRequestComponent } from './shared/export-request/export-request.component';
import { MsalInterceptor, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE } from '@azure/msal-angular';
import { SharedModule } from './shared/shared.module';
import { UserInfoComponent } from './shared/user-info/user-info.component';
import { AppInsightsService } from './services/common/appinsights.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { MsalAppConfigModule, MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './auth/auth-config.module';
import { MsalRedirectComponent } from './auth/msal-redirect.component';
import { NavBarMenuService } from './shared/topheader/service/nav-bar-menu.service';
import { MatStepperModule } 
    from '@angular/material/stepper';
import { BATRequestComponent } from './requests/bat-request/bat-request.component';
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { HttpErrorCode } from './enums/errors.enum';
import { DataTablesModule } from 'angular-datatables';
import { NgSelectModule } from '@ng-select/ng-select';
import { PopupComponent  } from "src/app/popup/popup.component";
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatCardModule } from '@angular/material/card';
import { BulkRequestComponent } from './bulkrequest/bulk-request/bulk-request.component';
import { RequestStatusComponent } from './request-status-reports/request-status/request-status.component';
import { TwoDigitDecimaNumberDirective } from './directives/appTwoDigitDecimal';
import { SidebarService } from './services/sidebar/sidebar.service';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
export class CustomHttpInterceptorService implements HttpInterceptor {
    constructor(private router: Router, private appConfigService: AppConfigService, private injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<
        | HttpSentEvent
        | HttpHeaderResponse
        | HttpProgressEvent
        | HttpResponse<any>
        | HttpUserEvent<any>
    > {
        let appInsights: AppInsightsService;
        const logTrace = (msg: string, err: any): void => {
            // ensure appConfigService loadAppConfig promise has returned before attempting to write logs
            if (this.appConfigService.appConfigAvailable() && appInsights != null) {
                // appInsights.logTrace(`HttpInterceptor error: ${msg} \n${JSON.stringify(err)}`);
            }
        };

        // console.log('CustomHttpInterceptorService intercept: ', req);
        return next.handle(req).pipe(tap(() => { },
            (err: any) => {
                // use Injector to initialize AppInsightsService only upon receipt of an error rather than via direct DependencyInjection
                // to allow our AppInitializer the chance to load the necessary AppConfig dependency
                if (appInsights == null) {
                    appInsights = this.injector.get(AppInsightsService);
                }
                if (err instanceof HttpErrorResponse) {
                    switch (err.status) {
                        // Note - see https://stackoverflow.com/questions/3297048/403-forbidden-vs-401-unauthorized-http-responses
                        // accepted answer for how this application will treat custom error conditions for 'access' permissions errors
                        case HttpErrorCode.NotFound:
                            logTrace('404 Not Found is http-intercepted by ng app module, redirect', err);
                            this.router.navigate([HttpErrorCode.NotFound.toString()]);
                            break;
                        case HttpErrorCode.Forbidden:
                            logTrace('403 Forbidden is http-intercepted by ng app module,..', err);
                            this.router.navigate([HttpErrorCode.Forbidden.toString()]);
                            break;
                        case HttpErrorCode.Unauthorized:
                            logTrace('401 Unauthorized is http-intercepted by ng app module,...', err);
                            this.router.navigate([HttpErrorCode.Unauthorized.toString()]);
                            break;
                        case HttpErrorCode.BadRequest:
                            logTrace('400 Bad Request is http-intercepted by ng app module,..', err);
                            // TODO - how best to handle without over-reaching
                            break;
                        default:
                            if (err.status === 0) {
                                logTrace('API offline/ connection refused', err);
                            } else {
                                logTrace('some other HttpInterceptor error', err);
                            }
                            break;
                    }
                }
            }));
    }
}

@NgModule({
    declarations: [
        AppComponent,
        UserInfoComponent,
        MsalComponent,
        MsalRedirectComponent,
        DashboardComponent,
        TwoDigitDecimaNumberDirective
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        HttpClientModule,
        MsalAppConfigModule.forRoot('./assets/app-config.json'),
        ModalModule,
        BrowserModule,
        SharedModule,
        CommonModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(),
        BsDatepickerModule,
        LoadingBarHttpClientModule,
        MatStepperModule,
        MatInputModule,
        MatButtonModule,
        NgSelectModule,
        PopupComponent,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatExpansionModule,
        MatTableModule,
        MatProgressSpinnerModule,
        NgxSpinnerModule.forRoot({type:'custom'}),
        MatCardModule,
        BulkRequestComponent,
        FlexLayoutModule      
    ],
    exports:[DataTablesModule],
    providers: [
        DatePipe,
        DecimalPipe,
        BsModalService,
        NavBarMenuService,
        MatDatepickerModule,
        AppConfigService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptorService,
            multi: true,
            deps: [Router, AppConfigService, Injector]
        },
        MsalModule,
        SidebarService
    ],
    bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {
}